<template>
  <div class="wrapper">
    <StepsBar :current="currentStep" />
    <router-view @setStep="setStep"></router-view>
  </div>
</template>
<script>
import StepsBar from "@/components/StepsBar.vue";
import Constants from "@/constants.js";
export default {
  name: "wrapper-component",
  components: {
    StepsBar,
  },
  watch: {
    $route(to) {
      const fieldInStorage = Constants.PREFIX + ".step";
      sessionStorage.setItem(fieldInStorage, to.name);
    },
  },
  data() {
    return {
      currentHeader: "haus",
      currentStep: 1,
    };
  },
  methods: {
    setStep(header, step) {
      this.currentHeader = header;
      this.currentStep = step;
    },
  },
};
</script>